import styled from 'styled-components';

export const BoxPictureTitle = styled.h1`
  font-size: 22px;
  font-weight: 700;
  word-wrap: break-word;
  color: #000;
`;
